import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { SingleLineTextAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/single-line-text-answer-config.model';
import { EdlCfAnswerSingleLineTextModel, EdlCfGenericModel, EdlCfSingleLineTextModel, MAX_PREFILL_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfSingleLineTextMapperService 
    implements IPaetepCfGenericMapperService<SingleLineTextAnswerConfig, EdlCfSingleLineTextModel, string, EdlCfAnswerSingleLineTextModel> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<SingleLineTextAnswerConfig>): EdlCfSingleLineTextModel => {
        return {
            title: child.label,
            prefill: child?.answerConfig?.prefill ?? '',
            isRequired: child.required
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfSingleLineTextModel>
    }): CustomFormQuestionDisplayDTO<SingleLineTextAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<SingleLineTextAnswerConfig>({
            formID,
            sectionID,
            questionID: question.id,
            $type: CustomFormQuestionType.SINGLE_LINE_TEXT,
            typeID: CustomFormQuestionType.SINGLE_LINE_TEXT,
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                prefill: (question.config.prefill ?? '').substring(0, MAX_PREFILL_LENGTH)
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<SingleLineTextAnswerConfig>) => answer;
}
